export default __webpack_public_path__ + "static/media/medium.476b3cc6.svg";